import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';

const ConfirmationDialog = ({ confirmationFun, declineFunction, open, setOpen, confirmationText }) => {
  const handleClose = () => {
    if (declineFunction) {
      declineFunction();
    }
    setOpen(false);
  };

  const handleConfirm = () => {
    if (confirmationFun) {
      confirmationFun();
    }
    setOpen(false);
  };
  return (
    <Dialog
      disablePortal
      disableAutoFocus
      fullWidth
      maxWidth="sm"
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}>
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        {confirmationFun ? 'Confirmation Needed' : 'Info Dialog'}
      </DialogTitle>
      <DialogContent sx={{ paddingBlock: '0.2rem' }}>
        <Box>
          <Typography sx={{ paddingBlock: '1rem' }} variant="subtitle1" component="h2">
            {confirmationText}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="error"
          size="small"
          onClick={
            declineFunction
              ? declineFunction
              : () => {
                  setOpen(false);
                }
          }>
          Cancel
        </Button>
        {confirmationFun && (
          <Button size="small" variant="contained" color="primary" onClick={handleConfirm}>
            Confirm
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
